export enum DocumentosTypes {
  SET_TIPO_DOCUMENTO = '@refinanciamento/documentos/SET_TIPO_DOCUMENTO',

  SHOW_LOADING = '@refinanciamento/documentos/SHOW_LOADING',
  HIDE_LOADING = '@refinanciamento/documentos/HIDE_LOADING',

  CAPTURA_DOCUMENTOS_REQUEST = '@refinanciamento/documentos/CAPTURA_DOCUMENTOS_REQUEST',
  CARREGAR_CAPTURA_REQUEST = '@refinanciamento/documentos/CARREGAR_CAPTURA_REQUEST',
  DOCUMENTOS_ASSINATURA_REQUEST = '@refinanciamento/documentos/DOCUMENTOS_ASSINATURA_REQUEST',
  BUSCAR_DOCUMENTOS_SAGA = '@refinanciamento/documentos/BUSCAR_DOCUMENTOS_SAGA',

  SET_NOME_CLIENTE = '@refinanciamento/documentos/SET_NOME_CLIENTE',
  SET_EMAIL = '@refinanciamento/documentos/SET_EMAIL',
  SET_VALOR_LIBERADO = '@refinanciamento/documentos/SET_VALOR_LIBERADO',
  SET_VALOR_PARCELA = '@refinanciamento/documentos/SET_VALOR_PARCELA',
  SET_QTD_PARCELAS = '@refinanciamento/documentos/SET_QTD_PARCELAS',
  SET_TAXA = '@refinanciamento/documentos/SET_TAXA',
  SET_CET = '@refinanciamento/documentos/SET_CET',
  SET_VALOR_TOTAL = '@refinanciamento/documentos/SET_VALOR_TOTAL',
  SET_ID_CLIENT = '@refinanciamento/documentos/SET_ID_CLIENT',
  SET_IS_REASSINATURA = '@refinanciamento/documentos/SET_IS_REASSINATURA',
  SET_CREDITO_PROTEGIDO = '@refinanciamento/documentos/SET_CREDITO_PROTEGIDO',
  RESET = 'RESET',

  SET_ETAPA_BUSCA = '@captura/documentos/SET_ETAPA_BUSCA',

  SET_ERRO_UPDATE_PROPOSAL = '@captura/documentos/SET_ERRO_UPDATE_PROPOSAL',
}

export interface DocumentosState {
  readonly tipoDocumento: string
  readonly loading: boolean
  readonly etapaBusca: number
}

export interface BuscarPayload {
  callback?: () => void
  callbackError?: () => void
}
